import {
  useSiteSettingsAndMetadata,
  UseSiteSettingsAndMetadata,
} from './useSiteSettingsAndMetadata'

export type UseSiteMetadata = NonNullable<UseSiteSettingsAndMetadata['site']>['siteMetadata']

export const useSiteMetadata = (): UseSiteMetadata => {
  const { site } = useSiteSettingsAndMetadata()
  return site?.siteMetadata
}
